import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo empieza la mentoría?',
  a: 'La mentoría arranca en cuanto se completan los cupos disponibles. Por eso los lugares son limitados: queremos un grupo chico, comprometido y de calidad. Una vez que reservás tu lugar, te avisamos por Gmail la fecha exacta del primer encuentro.'
}, {
  q: '¿Cuándo son los encuentros en vivo?',
  a: 'Los encuentros son semanales por Zoom. Una vez que reservás tu lugar, te sumamos al grupo privado de WhatsApp donde se comparten los links y horarios con anticipación.'
}, {
  q: '¿Qué pasa si no puedo ir a algún en vivo?',
  a: 'Todos los encuentros quedan grabados y disponibles para que los veas cuando puedas. No perdés nada si no podés conectarte en el momento.'
}, {
  q: '¿Por cuánto tiempo tengo acceso?',
  a: 'Tenés acceso completo durante toda la duración de la mentoría, incluyendo las grabaciones, el grupo privado y el material adicional.'
}, {
  q: '¿Necesito experiencia previa en desarrollo personal?',
  a: 'No. Esta mentoría es para personas que quieren resultados reales, no para los que ya saben todo en teoría. Si estás dispuesto a incomodarte y trabajar, es para vos.'
}, {
  q: '¿Cómo me sumo después de pagar?',
  a: 'Apenas confirmamos tu pago, te enviamos el link del grupo privado de WhatsApp directamente a tu Gmail. Todo pasa ahí: los links de Zoom, el material y el acompañamiento.'
}, {
  q: '¿Hay garantía?',
  a: 'Si en los primeros 7 días sentís que no es lo que esperabas, te devolvemos el dinero sin preguntas. La única condición es que hayas participado de al menos un encuentro en vivo.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-28">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[200px] bg-[#C9A84C]/5 rounded-full blur-[80px]" data-id="element-29" />

      <div className="container mx-auto px-4 relative z-10 max-w-3xl" data-id="element-30">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-31">
          <span className="text-[#C9A84C] tracking-[0.2em] text-xs font-bold uppercase mb-3 block" data-id="element-32">
            Antes de que te vayas sin comprar
          </span>
          <h2 className="text-4xl md:text-6xl font-['Bebas_Neue'] text-white" data-id="element-33">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-12 h-[1px] bg-[#C9A84C] mx-auto mt-4" data-id="element-34" />
        </motion.div>

        {/* Accordion */}
        <div className="space-y-2" data-id="element-35">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} className={`border transition-colors duration-200 ${open === i ? 'border-[#C9A84C]/40 bg-[#C9A84C]/5' : 'border-white/5 bg-[#111]'}`} data-id="element-36">
              <button className="w-full flex items-center justify-between px-6 py-5 text-left gap-4" onClick={() => setOpen(open === i ? null : i)} data-id="element-37">
                <span className={`text-base font-semibold transition-colors duration-200 ${open === i ? 'text-[#C9A84C]' : 'text-white'}`} data-id="element-38">
                  {faq.q}
                </span>
                <span className="shrink-0" data-id="element-39">
                  {open === i ? <Minus className="w-4 h-4 text-[#C9A84C]" data-id="element-40" /> : <Plus className="w-4 h-4 text-gray-500" data-id="element-41" />}
                </span>
              </button>

              <AnimatePresence initial={false} data-id="element-42">
                {open === i && <motion.div key="content" initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-43">
                    <p className="px-6 pb-5 text-gray-400 text-sm leading-relaxed" data-id="element-44">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}